module.exports = __webpack_public_path__ + "static/media/main-logo.543627dd.png";